import { render } from "./preco.vue?vue&type=template&id=6dab6edc"
import script from "./preco.vue?vue&type=script&lang=js"
export * from "./preco.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__